(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("MessageHistoryTable", [], factory);
	else if(typeof exports === 'object')
		exports["MessageHistoryTable"] = factory();
	else
		root["MessageHistoryTable"] = factory();
})(this, function() {
return 